<template>
    <div class="term_box">

    </div>
</template>

<script>
  import { Terminal } from 'xterm'  // 初始化组件
  import { AttachAddon } from 'xterm-addon-attach'
  import { FitAddon } from 'xterm-addon-fit'


    export default {
      name: "shell_term",
      props:{
        init_token:{
          type: String,
          default: ''
        },

        // login_result:{
        //   type:String,
        //   default:"",
        // },

        show_type:{
          type: String,
          default: '0',   //  界面展示形式， 0 弹框， 1 普通页面
        },

        current_route: {
          type: String,
          default: "/fort_service/webshell",  //  页面路由
        },

      },

      data() {
        return {
          term_init_param: {
            // rendererType: "canvas", //渲染类型
            // rows: 35, //行数
            // cols: 92,
            convertEol: true, //启用时，光标将设置为下一行的开头
            scrollback: 1000, //终端中的回滚量
            disableStdin: false, //是否应禁用输入
            cursorStyle: "block", //光标样式   underline / block /
            cursorBlink: true, //光标闪烁
            theme: {
              foreground: "#D3D5D7", //字体
              background: "#060101", //背景色
              cursor: "help" //设置光标
            },
          },

          target_term:"",
          login_result:"",
          cell_width: null,
          cell_height: null,

          msg_tag:{
            webshell: "webshell",   // 服务器接收通道
            resize: "resize",   // 服务器接收通道，resize,以逗号分割，width,height
            webshell_result: "webshell_result",   // 服务器返回通道，目标服务器webshell 结果通信
            webshell_timeout: "webshell_timeout",   // 服务器返回通道，目标服务器长时间没有操作超时
            webshell_exit: "webshell_exit",   // 服务器返回通道，目标服务器断开连接
            system_result: "system_result",   // 系统其他消息
            backlist: "backlist",   // 黑名单命令
          },

          ws:null,
          ws_url: null,

        }
      },

      beforeCreate(){

      },

      created(){


      },

      mounted(){
        if(!this.target_term){
          this.$nextTick(() =>{
            this.init_xterm()
          })

        }

        var _this = this
        if(this.show_type === "1"){
          window.addEventListener("resize", ()=> {   // 浏览器窗口大小改变

            // 终端组件初始化完成，websocket连接完成，且当前页面为webshell页面
            if(_this.target_term && _this.ws && _this.$router.currentRoute.path === _this.current_route){
              _this.fit_screen()
              _this.resize_term()
            }

          });
        }


        // var _this = this

        // this.$_socket.on('webshell_result', (data) => {
        //   console.log(data)
        //
        //   if(data.token && this.init_token == data.token){
        //     this.target_term.write(data.data)
        //   }
        //
        // });
        //
        //
        // this.$_socket.on("webshell_timeout", (data) =>{
        //   console.log(data)
        //   if(data.token && this.init_token == data.token){
        //     // this.$notify({
        //     //   title: '注意',
        //     //   duration: 0,
        //     //   message: data.data + ". 已关闭shell对话框"
        //     // });
        //     this.show_msg(data.data + ". 已关闭shell对话框","warning")
        //     this.$emit("shell_timeout")
        //   }
        // });
        //
        // this.$_socket.on("webshell_exit", (data) =>{
        //   console.log(data)
        // });
        //
        // this.$_socket.on("system_result", (data) =>{
        //   console.log(data)
        //   if(data.token && this.init_token == data.token){
        //     this.show_msg(data.data, "warning")
        //   }
        // });
        //
        // this.$_socket.on("backlist", (data) =>{
        //   console.log(data)
        //   if(data.token && this.init_token == data.token){
        //     // this.$notify({
        //     //   title: '注意',
        //     //   message: data.data
        //     // });
        //     this.show_msg(data.data, "warning")
        //   }
        //
        // });

        // this.init_xterm()
      },

      beforeDestroy(){
        this.close_term()
      },

      watch:{
        init_token(val){
          if(val){
            this.reconnect_ws()
          }
        },

      },

      methods:{

        // 初始化websocket   参数type: 新建（conn）/ 注销后重建（reconn）
        init_ws(part_url, type){
          var location_href = window.location.host
          var protocol = window.location.protocol
          var href_start = "ws://"
          if(this.$_startsWith("https", protocol)){
            href_start = "wss://"
          }
          location_href = href_start + location_href
          this.ws_url = `${location_href}/websocket/${part_url}`
          console.log(this.ws_url)

          var _this = this

          this.ws = new WebSocket(this.ws_url);

           this.ws.onopen = (evt) => this.ws_on_open(evt, type)     // websocket 连接建立时

           this.ws.onmessage = (evt) => this.ws_on_message(evt, type)   // 	websocket 客户端接收服务端数据时触发

           this.ws.onclose = function(evt) {
              // 关闭 websocket
              var msg = "Web Socket 连接已关闭... "
              if(!evt.wasClean){
                msg = "Web Socket 连接异常关闭 "
                _this.show_msg(msg + ". 已关闭shell对话框", "warning")
                _this.$emit("shell_closed")
              }
              console.log(msg + new Date().toLocaleString(),  evt);
           };

           this.ws.onerror = function (event) {
              console.error("WebSocket error observed:", event)
           }
        },

        // 注销并重新连接 websocket
        reconnect_ws(){
          console.log("Web Socket 注销并重新连接")
          if(this.ws){
            this.ws.close()
          }

          this.init_ws(this.init_token, "reconn")

        },


        // websocket连接建立事件
        ws_on_open(evt, type){
          console.log("Web Socket 已连接 " + new Date().toLocaleString());
          if( ((!this.cell_width || !this.cell_height) || type == 'reconn') && this.target_term ){
              this.resize_term()     // 向服务端发送行列数，适应屏幕大小
            }
        },

        // websocket客户端接收服务端数据事件
        ws_on_message(evt, type){

          var received_msg = JSON.parse(evt.data);
          // console.log(received_msg);
          if(received_msg.msg_tag == this.msg_tag.webshell_result){
            if(this.target_term){
              if( type == 'reconn' && received_msg.data.startsWith("Last login: ") ){
                this.target_term.write("\n")
              }
              this.target_term.write(received_msg.data)

            }else {
              this.login_result += received_msg.data
            }
          }else if(received_msg.msg_tag == this.msg_tag.webshell_timeout){
            this.show_msg(received_msg.data + ". 已关闭shell对话框","warning")
            this.$emit("shell_closed")

          }else if(received_msg.msg_tag == this.msg_tag.webshell_exit){
            this.show_msg(received_msg.data + ". 已关闭shell对话框", "warning")
            this.$emit("shell_closed")

          }else if(received_msg.msg_tag == this.msg_tag.system_result){
            this.show_msg(received_msg.data, "warning")

          }else if(received_msg.msg_tag == this.msg_tag.backlist){
            this.show_msg(received_msg.data, "warning")

          }

        },


        // 关闭xterm  关闭websocket连接
        close_term(){
          if(this.target_term){
            this.target_term.dispose()
            this.target_term = ""
            console.log("term is close")
          }
          if(this.ws){
            this.ws.close()
          }

        },


        // 初始化xterm
        init_xterm(){
          let _this = this; //一定要重新定义一个this，不然this指向会出问题

          this.login_result = ""
          this.init_ws(this.init_token, "conn")    // 初始化websocket

          // 初始化 xterm
          this.target_term = new Terminal(this.term_init_param);
          const term_dom = this.$el

          this.target_term.fitAddon = new FitAddon();
          this.target_term.loadAddon(this.target_term.fitAddon);

          this.target_term.open(term_dom);

          console.log('mounted is going on')
	        this.target_term.fitAddon.fit()  // 自适应宽高

          this.target_term.focus();

          function runFakeTerminal(_this) {
            if (_this.target_term._initialized) {
              return;
            }
            // 初始化
            _this.target_term._initialized = true;

            if(_this.login_result){
              _this.target_term.write(_this.login_result)
            }

            // term.writeln("Welcome to use Superman. ");
            // term.writeln(
            //   `This is Web Terminal of pod\x1B[1;3;31m ${
            //     _this.urlParam.podName
            //   }\x1B[0m in namespace\x1B[1;3;31m ${_this.urlParam.namespace}\x1B[0m`
            // );

            // _this.target_term.prompt();

            // / **
            //     *添加事件监听器，用于按下键时的事件。事件值包含
            //     *将在data事件以及DOM事件中发送的字符串
            //     *触发了它。
            //     * @返回一个IDisposable停止监听。
            //  * /
            //   / ** 更新：xterm 4.x（新增）
            //  *为数据事件触发时添加事件侦听器。发生这种情况
            //  *用户输入或粘贴到终端时的示例。事件值
            //  *是`string`结果的结果，在典型的设置中，应该通过
            //  *到支持pty。
            //  * @返回一个IDisposable停止监听。
            //  * /
            // 支持输入与粘贴方法
            _this.target_term.onData(function(key) {
              if(!_this.cell_width || !_this.cell_height){
                _this.resize_term()     // 向服务端发送行列数，适应屏幕大小
              }

              //这里key值是你输入的值
              _this.on_send(key);

            });

          }
          runFakeTerminal(_this);

        },

        // 发送数据
        on_send(data){
          // this.$socket.emit('webshell',data);
          // this.$_socket.emit('webshell',data);

          var datas = {
            token:this.init_token,
            shell:data,
            msg_tag: this.msg_tag.webshell,
          }
          this.ws.send(JSON.stringify(datas))

        },

        sendCommand(command){
          if(!command){
            return
          }
          if(!this.ws || this.ws.readyState !== 1){
            return
          }
          this.on_send(String(command) + "\r")
        },

        // 发送行列数据
        on_resize(data){
          // console.log(data)
          // this.$socket.emit('resize',data);
          // this.$_socket.emit('resize',data);

          var datas = {
            token:this.init_token,
            resize:data,
            msg_tag: this.msg_tag.resize,
          }
          this.ws.send(JSON.stringify(datas))
        },


        // 自适应屏幕
        fit_screen(){
          this.target_term.fitAddon.fit()
        },

        // 获取终端字符宽度 高度
        get_cell_size(term) {
          this.cell_width = term._core._renderService._renderer.dimensions.actualCellWidth;
          this.cell_height = term._core._renderService._renderer.dimensions.actualCellHeight;
          return {"width" : this.cell_width, "height": this.cell_height}
        },


        // 终端行列数
        resize_term(term_box_dom){
          if(!term_box_dom){
            term_box_dom = this.$el.parentElement
          }
          var cell_size = this.get_cell_size(this.target_term)

          // console.log(term_box_dom.style,cell_size)
          var cols = parseInt(term_box_dom.clientWidth / cell_size.width, 10) - 1;
          var rows = parseInt(term_box_dom.clientHeight / cell_size.height, 10);
          var resize_data = String(cols) + "," + String(rows)
          console.log(resize_data)
          this.on_resize(resize_data)
        },
      },


    }
</script>

<style scoped>
  .term_box{
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// shell_term.vue?3af8fa78